// src/components/UI/MonitorCard.jsx
import React from 'react';
import { Box, Heading, Text, Badge } from '@chakra-ui/react';

const MonitorCard = ({ title, description, status }) => {
  const isComingSoon = status === 'Em breve';

  return (
    <Box
      p={5}
      bg="surface"
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.800"
      cursor={isComingSoon ? 'not-allowed' : 'pointer'}
      transition="all 0.2s ease-in-out"
      _hover={!isComingSoon && {
        borderColor: 'secondary',
        transform: 'translateY(-2px)',
      }}
      opacity={isComingSoon ? 0.6 : 1}
    >
      <Heading as="h3" size="sm" color="white" mb={2}>{title}</Heading>
      <Text fontSize="sm" color="gray.400" mb={4}>{description}</Text>
      <Badge colorScheme={isComingSoon ? 'gray' : 'green'} variant="subtle">
        {status}
      </Badge>
    </Box>
  );
};

export default MonitorCard;